/** Compatibility export; the business domain owns this implementation. */
export { IAmazonMbaMarket, MBA_MARKETPLACE_SPECIFICATION } from '@domains/upload/shared';
